export const fetchActiveUsers = async (setActiveUsers, setStatusMessage) => {
  try {
    const response = await fetch(
      "https://wad-backend.ws381566.remote.ac/getActiveUsersAdmin.php?adminRequired=true",
      {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }
    );

    const result = await response.json();

    if (result.status === "authenticationError") {
      window.location.href = "/login";
      return;
    }

    if (result.status === "success") {
      setActiveUsers(result.users);
    } else {
      setStatusMessage(result.message || "Failed to execute query");
    }
  } catch (error) {
    setStatusMessage(error.message);
  }
};